// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import ExtraInformationActionType from './extra-information.types';
import {
	extraInformationAddSuccess,
	extraInformationAddFailure,
	extraInformationAddUserResponseChanged,
} from './extra-information.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { extraMemberInformationAdd } from './extra-information.service';

/** ***************** EXTRA INFORMATION SAGA START *********************** */
export function* ExtraInformationDetails({ payload }: any) {
	try {
		const key = 'ExtraInformationDetails';
		const {
			companyID,
			databaseName,
			memberID,
			bloodGroup,
			disablity,
			nameDisablity,
			identification,
			educationQualification,
			religion,
			caste,
			mailID,
			phoneType,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			BloodGroup: bloodGroup,
			Disablity: disablity,
			NameDisablity: nameDisablity,
			Identification: identification,
			EducationQualification: educationQualification,
			Religion: religion,
			Caste: caste,
			MailID: mailID,
			PhoneType: phoneType,
			OfficerID: userID,
			Secratekey: key,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(extraMemberInformationAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(extraInformationAddFailure(responseData.data));
		} else {
			yield put(extraInformationAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(extraInformationAddFailure(error));
	}
}

export function* ExtraInformationDetailsResponseClear() {
	yield put(extraInformationAddUserResponseChanged());
}

export function* onExtraInformationAddStart() {
	yield takeLatest(
		ExtraInformationActionType.EXTRA_INFORMATION_ADD_START,
		ExtraInformationDetails,
	);
}

export function* onExtraInformationAddResponseRest() {
	yield takeLatest(
		ExtraInformationActionType.EXTRA_INFORMATION_ADD_RESPONSE_REST_START,
		ExtraInformationDetailsResponseClear,
	);
}
/** ***************** EXTRA INFORMATION SAGA END *********************** */

export function* extraInformationSaga() {
	yield all([call(onExtraInformationAddStart), call(onExtraInformationAddResponseRest)]);
}
